var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getAdvanceMarketInfo } from "../../../api/marketData/advanceMarketInfo";
import { postAMBestFinsData } from "../../../api/marketData/amBestFinData";
import { postAMBestRatingsData } from "../../../api/marketData/amBestRatingsData";
import { getClientMarketAvailability } from "../../../api/marketData/clientMarketAvailability";
import { postMarketFactSheet } from "../../../api/marketData/marketFactSheetsData";
import { postMarketGuideData } from "../../../api/marketData/marketGuideData";
import { postSandPRatingsData } from "../../../api/marketData/sandPRatingsData";
import { GetRowHeight, columns } from "./ColumnHeader/column";
import { MarketListFilter } from "./filterPanel/FilterPanel";
import React, { useEffect, useState } from "react";
import "./MarketListContent.scss";
import { useClientPageStore, useErrorStore } from "../../../store";
import { AddAndDeleteMarketsDailog } from "../../Dailog/AddAndRemoveMarket";
import { addDeleteMarket } from "../../../api/marketData/addDeleteMarket";
import { formatDate } from "../../../constants/utilities";
import { useNavigate } from "react-router-dom";
import AonAgGridTable from "../../../components/core/AonAgGridTable/table";
export var MarketListContent = function (props) {
    var _a = useState([]), marketListData = _a[0], setMarketListData = _a[1];
    var _b = useState([]), addAndRemoveIds = _b[0], setAddAndRemoveIds = _b[1];
    var _c = useState(undefined), showMarketActions = _c[0], setShowMarketActions = _c[1];
    var _d = useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var _e = useState(null), gridAPI = _e[0], setGridApi = _e[1];
    var navigation = useNavigate();
    var errorStore = useErrorStore();
    var _f = React.useState({
        currentPage: 1,
        totalDatacount: undefined,
        pagesize: 1000,
        year: "",
        sortColumn: "",
        sortBy: "ASC",
        isError: false,
        retry: function () { },
        searchInput: "",
        advancePayload: undefined,
        refressPage: false
    }), pageConfig = _f[0], setPageConfig = _f[1];
    var clientStore = useClientPageStore();
    useEffect(function () {
        if (props.selectedClientGuuid && props.activeTab === 1) {
            fetchData();
        }
    }, [props.activeTab, props.selectedClientGuuid, pageConfig.currentPage, pageConfig.pagesize, pageConfig.searchInput, pageConfig.advancePayload, pageConfig.refressPage, pageConfig.sortBy, pageConfig.sortColumn]);
    var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var quickSearch, advanceSearchPayload, getClientMarketAvalResponse, sortColumn, marketInfoPayload, allMarketIds, getAvailableMarketInfo, totalCount_1, marketListData_1, levelTwoMarketId, allAPIPromises, allResponse_1, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    quickSearch = pageConfig.searchInput;
                    advanceSearchPayload = pageConfig.advancePayload;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, 7, 8]);
                    setIsLoading(true);
                    getClientMarketAvalResponse = undefined;
                    if (!(!quickSearch && !advanceSearchPayload)) return [3 /*break*/, 3];
                    return [4 /*yield*/, getClientMarketAvailability({ ClientGuid: props.selectedClientGuuid, Page: pageConfig.currentPage, PageSize: pageConfig.pagesize })];
                case 2:
                    getClientMarketAvalResponse
                        = _b.sent();
                    _b.label = 3;
                case 3:
                    sortColumn = pageConfig.sortColumn;
                    switch (sortColumn) {
                        case "MarketType":
                            sortColumn = "MarketTypeId";
                            break;
                        case "countryName":
                            sortColumn = "CountryCd";
                            break;
                        case "name":
                            sortColumn = "name";
                            break;
                        case "":
                            sortColumn = "name";
                            break;
                    }
                    marketInfoPayload = {
                        Sort: "".concat(sortColumn, " ").concat(pageConfig.sortBy), // no need to sorting at the time
                        page: pageConfig.currentPage,
                        pageSize: 1000,
                        preViewReViewGuideMode: 4, //hardcoded 4 always for client page current market list
                        isColleagueFlag: true, //hardcoded true always for client page current market list   
                    };
                    //level-two
                    if (getClientMarketAvalResponse) {
                        allMarketIds = getClientMarketAvalResponse.data.value.map(function (item) { return item.marketId; });
                        marketInfoPayload["marketIds"] = allMarketIds.join(",");
                        clientStore.storeActiveClientsId(allMarketIds);
                    }
                    else if (advanceSearchPayload) {
                        marketInfoPayload = __assign(__assign({}, marketInfoPayload), advanceSearchPayload);
                        marketInfoPayload["preViewReViewGuideMode"] = 3; //hardcoaded for advance search in client page
                    }
                    else {
                        marketInfoPayload["quickSearch"] = quickSearch;
                        marketInfoPayload["preViewReViewGuideMode"] = 3;
                    }
                    if (getClientMarketAvalResponse && !marketInfoPayload["marketIds"]) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, getAdvanceMarketInfo(marketInfoPayload)];
                case 4:
                    getAvailableMarketInfo = _b.sent();
                    totalCount_1 = getAvailableMarketInfo.headers["x-total-count"];
                    setPageConfig(function (prev) { return (__assign(__assign({}, prev), { totalDatacount: totalCount_1 })); }); //settting up the total data count;
                    marketListData_1 = [];
                    setAddAndRemoveIds([]); // reseting in case of new data.
                    levelTwoMarketId = (_a = getAvailableMarketInfo.data.value.map(function (item) { return item.marketId; })) === null || _a === void 0 ? void 0 : _a.join(",");
                    allAPIPromises = Promise.all([
                        postMarketGuideData({ MarketIds: levelTwoMarketId }),
                        postAMBestRatingsData({ MarketIds: levelTwoMarketId }),
                        postAMBestFinsData({ MarketIds: levelTwoMarketId }),
                        postMarketFactSheet({ MarketIds: levelTwoMarketId }),
                        postSandPRatingsData({ MarketIds: levelTwoMarketId })
                    ]);
                    return [4 /*yield*/, allAPIPromises];
                case 5:
                    allResponse_1 = _b.sent();
                    marketListData_1 = getAvailableMarketInfo.data.value.map(function (item) {
                        var marketGuideData = allResponse_1[0].data.value.find(function (guideData) { return guideData.marketId === item.marketId; });
                        var bestRatingData = allResponse_1[1].data.value.find(function (ratingData) { return ratingData.marketId === item.marketId; });
                        var finaceData = allResponse_1[2].data.value.find(function (ratingfinData) { return ratingfinData.marketId === item.marketId; });
                        var factSheetData = allResponse_1[3].data.value.find(function (factSheetData) { return factSheetData.marketId === item.marketId; });
                        var sAndpRatingData = allResponse_1[4].data.value.find(function (sAndpRatingData) { return sAndpRatingData.marketId === item.marketId; });
                        var isActive = clientStore.activeClientIds.includes(item.marketId);
                        return ({
                            marketId: item.marketId,
                            name: item.name || '',
                            groupName: item.groupName,
                            marketCategoryName: item.marketCategoryName,
                            marketTypeId: item.marketTypeId,
                            countryName: item.countryName,
                            advisoryFlag: marketGuideData === null || marketGuideData === void 0 ? void 0 : marketGuideData.advisoryFlag,
                            advisoryDocGuid: (marketGuideData === null || marketGuideData === void 0 ? void 0 : marketGuideData.advisoryDocGuid) || '',
                            marketGuideStatus: marketGuideData === null || marketGuideData === void 0 ? void 0 : marketGuideData.marketGuideStatus,
                            doNotUseFlag: marketGuideData === null || marketGuideData === void 0 ? void 0 : marketGuideData.doNotUseFlag,
                            reinsuranceIndicator: item.reinsuranceInsuranceIndicatorDesc || '',
                            permittedUse: (marketGuideData === null || marketGuideData === void 0 ? void 0 : marketGuideData.comment) || '',
                            bestRating: bestRatingData === null || bestRatingData === void 0 ? void 0 : bestRatingData.bestRating,
                            ratingOutlook: bestRatingData === null || bestRatingData === void 0 ? void 0 : bestRatingData.ratingOutlook,
                            amBestId: bestRatingData === null || bestRatingData === void 0 ? void 0 : bestRatingData.amBestId,
                            amBestRatingDate: formatDate(bestRatingData === null || bestRatingData === void 0 ? void 0 : bestRatingData.ratingDate),
                            amBestRatingExplanation: bestRatingData === null || bestRatingData === void 0 ? void 0 : bestRatingData.ratingExplanation,
                            sandPRating: sAndpRatingData === null || sAndpRatingData === void 0 ? void 0 : sAndpRatingData.sandPRating,
                            sAndPRatingOutlook: sAndpRatingData === null || sAndpRatingData === void 0 ? void 0 : sAndpRatingData.ratingOutlook,
                            sAndPId: sAndpRatingData === null || sAndpRatingData === void 0 ? void 0 : sAndpRatingData.sandPId,
                            sAndpRatingDate: formatDate(sAndpRatingData === null || sAndpRatingData === void 0 ? void 0 : sAndpRatingData.ratingDate),
                            sAndpRatingExplanation: sAndpRatingData === null || sAndpRatingData === void 0 ? void 0 : sAndpRatingData.ratingExplanation,
                            keyFinancialAsOfDate: formatDate(finaceData === null || finaceData === void 0 ? void 0 : finaceData.keyFinancialAsOfDate),
                            surplusValue: finaceData ? getPHsandASHFValue(finaceData) : "",
                            factSheetDate: formatDate(factSheetData === null || factSheetData === void 0 ? void 0 : factSheetData.dateTimeUTCStamp),
                            factSheetDocumentGuid: factSheetData === null || factSheetData === void 0 ? void 0 : factSheetData.documentGuid,
                            isActive: isActive,
                            marketGuid: item.marketGuid,
                            isSelectionDisabled: (!!quickSearch && isActive) || !clientStore.isUserHaveFullAccess
                        });
                    });
                    //console.log(marketListData)
                    setMarketListData(marketListData_1);
                    setPageConfig(function (prev) { return (__assign(__assign({}, prev), { isError: false })); });
                    return [3 /*break*/, 8];
                case 6:
                    error_1 = _b.sent();
                    setMarketListData([]);
                    setPageConfig(function (prev) { return (__assign(__assign({}, prev), { isError: true, retry: function () { fetchData(); } })); });
                    errorStore.showError({ message: "Error", code: "500" });
                    navigation('/error');
                    return [3 /*break*/, 8];
                case 7:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var getPHsandASHFValue = function (finaceData) {
        var surplusValue = 0;
        if (Boolean(finaceData.policyholdersSurplus.applicableToMarketFlag)) {
            surplusValue = finaceData.policyholdersSurplus.value;
        }
        else if (Boolean(finaceData.adjustedShareholdersFunds.applicableToMarketFlag)) {
            surplusValue = finaceData.adjustedShareholdersFunds.value;
        }
        else if (Boolean(finaceData.capitalSurplus.applicableToMarketFlag)) {
            surplusValue = finaceData.capitalSurplus.value;
        }
        else if (Boolean(finaceData.capacity.applicableToMarketFlag)) {
            surplusValue = finaceData.capacity.value;
        }
        else if (Boolean(finaceData.estimatedAssetsUnderManagement.applicableToMarketFlag)) {
            surplusValue = finaceData.estimatedAssetsUnderManagement.value;
        }
        var updatedSurplusValue = Math.round((surplusValue * finaceData.exchangeRateToUSD / 1000) * 10) / 10;
        return updatedSurplusValue;
    };
    var handlePageChangeRequest = function (page) {
        page = page.detail.page;
        gridAPI === null || gridAPI === void 0 ? void 0 : gridAPI.ensureIndexVisible(0, "top");
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
        setPageConfig(function (prev) {
            return (__assign(__assign({}, prev), { currentPage: page }));
        });
    };
    var addMarket = function () {
        setShowMarketActions("ADD");
    };
    var removeMarket = function () {
        setShowMarketActions("DELETE");
    };
    var handleMarketSubmitAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var apiPayload, apiPayload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(showMarketActions === "ADD")) return [3 /*break*/, 2];
                    apiPayload = addAndRemoveIds.filter(function (item) { return item.addDelete === 1; });
                    apiPayload = apiPayload.map(function (item) {
                        delete item.selectedRow;
                        return item;
                    });
                    return [4 /*yield*/, addDeleteMarket(apiPayload)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    apiPayload = addAndRemoveIds.filter(function (item) { return item.addDelete === 2; });
                    apiPayload = apiPayload.map(function (item) {
                        delete item.selectedRow;
                        return item;
                    });
                    return [4 /*yield*/, addDeleteMarket(apiPayload)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    setPageConfig(function (prev) { return (__assign(__assign({}, prev), { currentPage: 1, pagesize: 100, searchInput: "", advancePayload: undefined, refressPage: !prev.refressPage })); });
                    setShowMarketActions(undefined);
                    return [2 /*return*/];
            }
        });
    }); };
    var onSelected = function (index, event) {
        event.preventDefault();
        var _marketListContent = __spreadArray([], marketListData, true);
        var selectedRow = _marketListContent[index];
        var _addRemoveIds = __spreadArray([], addAndRemoveIds, true);
        var findIndex = _addRemoveIds.findIndex(function (item) { return item.marketGuid === selectedRow.marketGuid; });
        if (selectedRow.isActive) {
            if (clientStore.activeClientIds.includes(selectedRow.marketId)) {
                if (findIndex >= 0) {
                    _addRemoveIds[findIndex] = __assign(__assign({}, _addRemoveIds[findIndex]), { addDelete: 2, changeComment: "Changed by colleague in MarketPreView" });
                }
                else {
                    _addRemoveIds.push({
                        clientGuid: props.selectedClientGuuid,
                        marketGuid: selectedRow.marketGuid,
                        changeComment: "Changed by colleague in MarketPreView",
                        addDelete: 2,
                        selectedRow: selectedRow
                    });
                }
            }
            else {
                if (findIndex >= 0) {
                    _addRemoveIds.splice(findIndex, 1);
                }
            }
        }
        else if (!clientStore.activeClientIds.includes(selectedRow.marketId)) {
            if (findIndex >= 0) {
                _addRemoveIds[findIndex] = __assign(__assign({}, _addRemoveIds[findIndex]), { addDelete: 1, changeComment: "" });
            }
            else {
                _addRemoveIds.push({
                    clientGuid: props.selectedClientGuuid,
                    marketGuid: selectedRow.marketGuid,
                    changeComment: "Changed by colleague in MarketPreView",
                    addDelete: 1,
                    selectedRow: selectedRow
                });
            }
        }
        else if (clientStore.activeClientIds.includes(selectedRow.marketId)) {
            if (findIndex >= 0) {
                _addRemoveIds.splice(findIndex, 1);
            }
        }
        _marketListContent[index].isActive = !_marketListContent[index].isActive;
        setAddAndRemoveIds(_addRemoveIds);
        setMarketListData(_marketListContent);
    };
    var handleSortingFuntions = function (sortColumn) {
        var revertSortBy = function (sBy) { return sBy === "DESC" ? "ASC" : "DESC"; };
        if (sortColumn === pageConfig.sortColumn) {
            setPageConfig(function (prev) {
                return (__assign(__assign({}, prev), { sortColumn: sortColumn, sortBy: revertSortBy(pageConfig.sortBy) }));
            });
        }
        else {
            setPageConfig(function (prev) {
                return (__assign(__assign({}, prev), { sortColumn: sortColumn, sortBy: "DESC" }));
            });
        }
    };
    var isAddMarketEnable = addAndRemoveIds.find(function (item) { return item.addDelete === 1; }) && clientStore.isUserHaveFullAccess;
    var isDeleteMarketEnable = addAndRemoveIds.find(function (item) { return item.addDelete === 2; }) && clientStore.isUserHaveFullAccess;
    var handleQuickSearch = function (search) {
        setPageConfig(function (prev) { return (__assign(__assign({}, prev), { searchInput: search, advancePayload: undefined, currentPage: 1, pagesize: 100, refressPage: !prev.refressPage })); });
    };
    var handleAdvanceSearch = function (payload) {
        setPageConfig(function (prev) { return (__assign(__assign({}, prev), { searchInput: "", advancePayload: payload, currentPage: 1, pagesize: 100 })); });
    };
    var _g = useState(window.innerHeight), currentInneHeight = _g[0], setcurrentInneHeight = _g[1];
    useEffect(function () {
        var updateSize = function () {
            var innerHeight = window.innerHeight;
            setcurrentInneHeight(innerHeight);
        };
        window.addEventListener("resize", updateSize);
        return function () {
            window.removeEventListener("resize", updateSize);
        };
    }, []);
    return (React.createElement("div", { className: "client-list-box" },
        React.createElement(MarketListFilter, { removeMarket: isDeleteMarketEnable ? removeMarket : undefined, addMarket: isAddMarketEnable ? addMarket : undefined, handleAdvanceSearch: function (payload) { return handleAdvanceSearch(payload); }, clientGuid: props.selectedClientGuuid, onClickClear: function () { handleQuickSearch(""); }, onClickSearch: function (value) { handleQuickSearch(value); }, gridData: marketListData }),
        React.createElement("div", { className: "spacer" },
            React.createElement(AonAgGridTable
            //height={currentInneHeight}
            , { 
                //height={currentInneHeight}
                rowData: marketListData, columns: columns(onSelected, isLoading, pageConfig.sortColumn, pageConfig.sortBy, handleSortingFuntions), loading: isLoading, pagination: true, currentPage: pageConfig.currentPage, totalCount: pageConfig.totalDatacount, pageSize: 1000, onPageChange: handlePageChangeRequest, RowHeightCallback: GetRowHeight, suppressScrollOnNewData: true, setCurrentGridAPI: setGridApi })),
        showMarketActions && React.createElement(AddAndDeleteMarketsDailog, { selectedRows: addAndRemoveIds, onClickSubmit: handleMarketSubmitAction, dailogType: showMarketActions, showDailog: true, onClickClose: function () { return setShowMarketActions(undefined); } })));
};
